import { Divider } from 'antd';
import styled from 'styled-components';

export const StyledDivider = styled(Divider)`
  margin: 0px;
  border-color: #e0e0e0;
`;
